import { render, staticRenderFns } from "./GuiaResumoInternacao.vue?vue&type=template&id=6225c787&"
import script from "./GuiaResumoInternacao.vue?vue&type=script&lang=js&"
export * from "./GuiaResumoInternacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports